import { Outlet, Link, useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaClipboardList } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import Logo from '../../../components/common/Logo';

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse" style={{ minHeight: '100vh' }}>
          <div className="position-sticky pt-3">
            <div className="px-3 mb-4">
              <div className="mb-2">
                <Logo size="small" showText={false} />
              </div>
              <div className="d-flex align-items-center">
                <FaUser className="text-muted me-2" />
                <small className="text-muted">{user?.get('email')}</small>
              </div>
            </div>

            <ul className="nav flex-column">
              <li className="nav-item">
                <Link 
                  to="/dashboard/quotations" 
                  className="nav-link d-flex align-items-center gap-2"
                >
                  <FaClipboardList />
                  Mis Cotizaciones
                </Link>
              </li>
            </ul>

            <div className="px-3 mt-4">
              <button
                onClick={handleLogout}
                className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
              >
                <FaSignOutAlt />
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="col-md-9 col-lg-10 ms-sm-auto px-md-4">
          <div className="py-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
